const AVATAR_COLORS = [
    'rgb(113, 237, 170)',
    'rgb(113, 237, 217)',
    'rgb(177, 113, 237)',
    'rgb(191, 237, 113)',
    'rgb(113, 162, 237)',
    'rgb(237, 113, 113)',
];

const GROUP_ICON_COLORS = [
    'rgb(47, 128, 237)',
    'rgb(17, 232, 116)',
    'rgb(242, 153, 74)',
    'rgb(155, 81, 224)',
    'rgb(235, 87, 87)',
];

const hashString = (str = '') => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
};

const pickColorByHash = (identifier, colors) =>
    colors[Math.abs(hashString(identifier)) % colors.length];

export const getAvatarColor = (identifier) =>
    pickColorByHash(identifier, AVATAR_COLORS);

export const getGroupColor = (identifier) =>
    pickColorByHash(identifier, GROUP_ICON_COLORS);
